import React, { useState } from "react";

import { ChevronDown, ChevronUp, Users, TriangleAlert, CheckCircle } from "lucide-react";

interface ITeam {
    name: string;
    riskScore: number;
    employees: number;
    trainingCompleted: number;
    actionItems: number;
};
export const DepartmentRiskDistribution = () => {

    const teams: ITeam[] = [
        {
            name: 'Engineering',
            riskScore: 45,
            employees: 100,
            trainingCompleted: 80,
            actionItems: 20,
        },
        {
            name: 'Sales',
            riskScore: 78,
            employees: 38,
            trainingCompleted: 12,
            actionItems: 3,
        },
        {
            name: 'HR',
            riskScore: 62,
            employees: 100,
            trainingCompleted: 80,
            actionItems: 20,
        },
        {
            name: 'Finance',
            riskScore: 71,
            employees: 100,
            trainingCompleted: 80,
            actionItems: 20,
        },
        {
            name: 'Marketing',
            riskScore: 58,
            employees: 100,
            trainingCompleted: 80,
            actionItems: 20,
        },
        {
            name: 'Executive',
            riskScore: 38,
            employees: 100,
            trainingCompleted: 80,
            actionItems: 20,
        },
    ];

    const [selectedTeamIdx, setSelectedTeamIdx] = useState<number | null>(null);

    const getTeamRALevel = (riskScore: number): 'high' | 'medium' | 'low' => {
        if (riskScore <= 45) return 'low';
        if (riskScore <= 70) return 'medium';
        return 'high';
    };

    return (
        <div className='card card--md card--radius-md card--hover-shadow dashboard__mcsa__department_risk_distribution'>
            <div className='d-flex justify-content-between align-items-center mb-xl'>
                <div>
                    <p className='text-lg text-semibold'>Department Risk Distribution</p>
                    <p className='text-sm color--txt-muted'>Click on a department to view details</p>
                </div>
                <div className='d-flex align-items-center gap-sm'>
                    <div className='dashboard__mcsa__department_risk_distribution__risk_legend dashboard__mcsa__department_risk_distribution__risk_legend--high'>
                        <div />
                        <p className='text-sm color--txt-secondary'>High Risk</p>
                    </div>
                    <div className='dashboard__mcsa__department_risk_distribution__risk_legend dashboard__mcsa__department_risk_distribution__risk_legend--medium'>
                        <div />
                        <p className='text-sm color--txt-secondary'>Medium Risk</p>
                    </div>
                    <div className='dashboard__mcsa__department_risk_distribution__risk_legend dashboard__mcsa__department_risk_distribution__risk_legend--low'>
                        <div />
                        <p className='text-sm color--txt-secondary'>Low Risk</p>
                    </div>
                </div>
            </div>

            <div className='dashboard__mcsa__department_risk_distribution__teams_cards'>
                {teams.map((team, idx) => (
                    <button
                        key={team.name}
                        className={`card card--sm card--radius-sm card--hover-scale ${selectedTeamIdx === idx ? 'card--selected' : ''} dashboard__mcsa__department_risk_distribution__teams_cards__card dashboard__mcsa__department_risk_distribution__teams_cards__card--${getTeamRALevel(team.riskScore)}`}
                        onClick={() => setSelectedTeamIdx(selectedTeamIdx === idx ? null : idx)}
                    >
                        <div className='d-flex justify-content-between align-items-center mb-md'>
                            <p className='text-sm text-medium text-left'>{team.name}</p>
                            <div className='dashboard__mcsa__department_risk_distribution__teams_cards__card__icon'>
                                {getTeamRALevel(team.riskScore) === 'low' ? <ChevronDown /> : getTeamRALevel(team.riskScore) === 'medium' ? <div /> : <ChevronUp />}
                            </div>
                        </div>
                        <div className='d-flex justify-content-between align-items-center mb-xs'>
                            <p className='text-xs color--txt-muted'>Risk Level</p>
                            <p className='text-xs color--txt-muted'>{team.riskScore}%</p>
                        </div>
                        <div className='dashboard__mcsa__department_risk_distribution__teams_cards__card__progress_bar'>
                            <div className='dashboard__mcsa__department_risk_distribution__teams_cards__card__progress_bar__inner' style={{ width: `${team.riskScore}%` }} />
                        </div>
                        <div className='d-flex justify-content-between align-items-center mt-md'>
                            <div className='dashboard__mcsa__department_risk_distribution__teams_cards__card__team_members_ct'>
                                <Users className='color--txt-muted' />
                                <p className='text-xs color--txt-muted'>{team.employees}</p>
                            </div>
                            <div className='dashboard__mcsa__department_risk_distribution__teams_cards__card__risk_level'>
                                {getTeamRALevel(team.riskScore) === 'high' ? <TriangleAlert /> : <CheckCircle />}
                                <p className='text-xs'>{getTeamRALevel(team.riskScore)[0].toUpperCase() + getTeamRALevel(team.riskScore).slice(1)}</p>
                            </div>
                        </div>
                    </button>
                ))}
            </div>

            {selectedTeamIdx !== null && (
                <div className='card card--sm card--radius-sm mt-xl'>
                    <div className='d-flex justify-content-evenly align-items-center'>
                        <div className='d-flex flex-column align-items-center w-full'>
                            <p className='text-2xl text-bold'>{teams[selectedTeamIdx].riskScore}%</p>
                            <p className='text-sm color--txt-muted'>Risk Score</p>
                        </div>
                        <div className='d-flex flex-column align-items-center w-full'>
                            <p className='text-2xl text-bold'>{teams[selectedTeamIdx].employees}</p>
                            <p className='text-sm color--txt-muted'>Employees</p>
                        </div>
                        <div className='d-flex flex-column align-items-center w-full'>
                            <p className='text-2xl text-bold color--success'>{teams[selectedTeamIdx].trainingCompleted}</p>
                            <p className='text-sm color--txt-muted'>Training Completed</p>
                        </div>
                        <div className='d-flex flex-column align-items-center w-full'>
                            <p className='text-2xl text-bold color--warning'>{teams[selectedTeamIdx].actionItems}</p>
                            <p className='text-sm color--txt-muted'>Action Items</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};